import React from 'react';

// 寧可從缺 applied to the TEXT, not just to a gloss. This paragraph's Chinese
// names seven planets; the Formosan names four, because three clauses are
// digitally silent in the recording (−80 dB inside those windows against a
// −50 dB room-tone floor everywhere else in the same book). Trimming the Chinese
// to match would have made the two columns agree by deleting the evidence that
// something is missing — a learner comparing them has to be told the 族語 is
// SHORT here, not wrong, and that it is coming.
export default function GapNote({ gaps }) {
  if (!gaps || !gaps.length) return null;
  return (
    <div className="sv-gaps">
      {gaps.map((g, i) => (
        <p className="sv-gap" key={i}>
          <span className="sv-gap-mark">缺</span>
          <span>中文有、族語沒有：「{g.zh}」{g.note ? `（${g.note}）` : ''}</span>
        </p>
      ))}
    </div>
  );
}
